// extracted by mini-css-extract-plugin
module.exports = {"submitBtn":"AddressForm_submitBtn__vbbrc","flexContainer":"AddressForm_flexContainer__1-5jI","locationSpinner":"AddressForm_locationSpinner__1ojjH"};